module.exports = __webpack_public_path__ + "img/menu-dx.89e253aa.png";